export enum HandledIndexDBErrors {
  NO_DATABASE = 'InvalidStateError: A mutation operation was attempted on a database that did not allow mutations.',
}
